import styled from "styled-components";

export const Styles = styled.div`
  .ant-upload.ant-upload-drag .ant-upload {
    padding: 0;
  }

  &.attachment-table:has(.ant-upload-list-text-container) {
    .ant-upload-drag.ant-upload-disabled {
      display: none !important;
    }
    .ant-upload.ant-upload-drag {
      border: none;
      display: flex;
      background: none;
      justify-content: end;
      .ant-upload.ant-upload-btn {
        width: 56px;
        border: 1px dashed #d9d9d9;
      }
    }
    .icon_attachment {
      font-size: 14px !important;
      width: 20px !important;
      height: 10px !important;
    }
    .ant-input {
      height: 12px;
      min-height: 12px;
      border: none;
      font-size: 1px;
      padding: 0;
    }
  }

  &.disabled:has(.ant-upload-list-text-container) {
    .item-list-file {
      min-height: 0px;
      justify-content: center !important;
    }
    .ant-upload-btn {
      display: none;
    }
    .actions_file {
      display: none !important;
    }
  }

  &.attachment.disabled:has(.ant-upload-list-text-container) {
    .item-list-file-content {
      max-width: 100%;
    }
  }

  .item-list-file-content {
    display: flex;
    align-items: center;
    max-width: calc(100% - 55px);
    position: relative;
  }
`;
